import { render, staticRenderFns } from "./ReferencesLibrary.vue?vue&type=template&id=ba1d8590&scoped=true&"
import script from "./ReferencesLibrary.vue?vue&type=script&lang=js&"
export * from "./ReferencesLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ReferencesLibrary.vue?vue&type=style&index=0&id=ba1d8590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1d8590",
  null
  
)

export default component.exports